


































import Vue from 'vue';
import { FullscreenWrapper } from '@/components/fullscreen-wrapper-components/index';
import { CloseFullscreenWrapper } from '@/mixins/index';
import { ExtendMixins } from '@/services';

interface Data {
  pageTitle: string;
  pageSubtitle: string;
  pageDescription: string;
  content: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
).extend({
  name: 'PrintContentArea',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      pageTitle: this.params.title,
      pageSubtitle: this.params.subtitle,
      pageDescription: this.params.description,
      content: this.params.content,
    };
  },
  methods: {
    print(): void {
      window.print();
    },
  },
  components: {
    FullscreenWrapper,
  },
});
